

















































































































































































import Vue from "vue";
import { Form } from "element-ui";
import { axios } from "../../plugins";
import { mapState, mapGetters } from "vuex";

interface UserItem {
  userId: string;
  userName: string;
}

interface UserId {
  userId: string;
}
const protocol = ["TCP", "UDP"];

const ServiceForm = {
  apiVersion: "v1",
  kind: "Service",
  metadata: {
    annotations: {
      "appmgr.object.description": "",
      "appmgr.object.createBy": ""
    },
    name: "",
    namespace: ""
  },
  spec: {
    ports: [
      {
        name: "",
        port: undefined,
        protocol: "TCP",
        targetPort: undefined
      }
    ],
    type: "ClusterIP",
    sessionAffinity: "ClientIP",
    sessionAffinityConfig: {
      clientIP: {
        timeoutSeconds: 10800
      }
    },
    selector: {}
  }
};

export default Vue.extend({
  name: "Edit",
  props: {
    projectId: { type: String }
  },
  data() {
    return {
      dialog: false,
      isEdit: false,
      loading: false,
      protocol,

      ruleForm: JSON.parse(JSON.stringify(ServiceForm)) as typeof ServiceForm,
      rules: {
        "metadata.name": [
          {
            required: true,
            message: "",
            trigger: "blur",
            pattern: /^[a-z0-9-]+$/
          }
        ],
        portOrEnvItem: [{ required: true, type: "string", trigger: "change" }],
        port: [
          {
            required: true,
            type: "number",
            trigger: "change",
            min: 0,
            max: 65535
          }
        ],
        "spec.ports": [{ required: true, type: "array", min: 1 }],
        "spec.sessionAffinityConfig.clientIP.timeoutSeconds": [
          { required: true, type: "number", min: 0 }
        ]
      },
      appOptions: [] as any,
      typeOptions: [
        { label: "集群IP", value: "ClusterIP" },
        { label: "无头服务", value: "None" },
        { label: "节点端口", value: "NodePort" },
        { label: "负载均衡", value: "LoadBalancer" }
      ],
      // 开启会话保持
      checked: false,
      // 负载类型
      loadType: "Deployment",
      //  所属组件
      app: ""
    };
  },
  computed: {
    ...mapState("LoginInfo", ["userinfo", "project"]),
    ...mapGetters("LoginInfo", ["tenant"]),
    filterAppOptions() {
      // @ts-ignore
      return this.appOptions.filter(
        // @ts-ignore
        (option: any) => option.loadType === this.loadType
      );
    }
  },
  mounted() {
    // @ts-ignore
    this.getAppOptions();
  },
  methods: {
    show(data?: typeof ServiceForm) {
      if (data) {
        // 编辑模式
        // @ts-ignore
        this.isEdit = true;
        // @ts-ignore
        this.ruleForm = JSON.parse(JSON.stringify(data));
        // @ts-ignore
        this.ruleForm.apiVersion = "v1";
        // @ts-ignore
        this.ruleForm.kind = "Service";
        // 删除多余参数
        // @ts-ignore
        delete (this.ruleForm as any).status;
        // @ts-ignore
        this.checked = data.spec.sessionAffinity === "ClientIP";
      } else {
        // @ts-ignore
        this.isEdit = false;
        // @ts-ignore
        this.ruleForm.metadata.annotations[
          "appmgr.object.createBy"
        ] = this.userinfo.username;
      }
      // @ts-ignore
      this.dialog = true;
    },
    // 负载类型切换响应
    getAppOptions() {
      axios.get(`/project/${this.projectId}/component`).then(res => {
        // @ts-ignore
        this.appOptions = res.data.data;
      });
    },
    checkChange(bool: boolean) {
      if (bool) {
        // @ts-ignore
        this.ruleForm.spec.sessionAffinity = "ClientIP";
        // @ts-ignore
        this.ruleForm.spec.sessionAffinityConfig = {
          clientIP: {
            timeoutSeconds: 10800
          }
        };
      } else {
        // @ts-ignore
        this.ruleForm.spec.sessionAffinity = "None";
        // @ts-ignore
        delete this.ruleForm.spec.sessionAffinityConfig;
      }
    },
    appChange(val: string) {
      // @ts-ignore
      const data = this.filterAppOptions.find((option: any) => {
        return option.name === val;
      });
      // @ts-ignore
      this.ruleForm.spec.selector = data.selectorLabel;
    },

    addPort() {
      // @ts-ignore
      this.ruleForm.spec.ports.push({
        name: "",
        port: undefined,
        protocol: "TCP",
        targetPort: undefined
      });
    },
    delPort(index: number) {
      // @ts-ignore
      if (this.ruleForm.spec.ports.length === 1) return;
      // @ts-ignore
      this.ruleForm.spec.ports.splice(index, 1);
    },
    quit() {
      // @ts-ignore
      this.ruleForm = JSON.parse(
        JSON.stringify(ServiceForm)
      ) as typeof ServiceForm;
      // @ts-ignore
      this.checked = true;
      // @ts-ignore
      this.loadType = "Deployment";
      // @ts-ignore
      this.app = "";
      this.$nextTick(() => {
        (this.$refs.ruleForm as Form).clearValidate();
        // @ts-ignore
        this.dialog = false;
      });
    },
    submit() {
      (this.$refs.ruleForm as Form).validate(vakid => {
        if (vakid) {
          // @ts-ignore
          this.loading = true;
          // @ts-ignore
          if (this.isEdit) {
            // @ts-ignore
            this.edit();
          } else {
            // @ts-ignore
            this.create();
          }
        }
      });
    },
    edit() {
      axios
        // @ts-ignore
        .put(`/service/${this.projectId}`, this.ruleForm)
        .then(() => {
          this.$message.success("服务修改成功！");
          // @ts-ignore
          this.quit();
          this.$emit("afterEdit");
        })
        .finally(() => {
          // @ts-ignore
          this.loading = false;
        });
    },
    create() {
      // @ts-ignore
      this.ruleForm.metadata.namespace = `${this.tenant.code}-${this.project.projectName}`;
      // @ts-ignore
      if (this.ruleForm.spec.type === "None") {
        // @ts-ignore
        this.ruleForm.spec = Object.assign({}, this.ruleForm.spec, {
          clusterIP: "None",
          type: "ClusterIP"
        });
      }

      axios
        // @ts-ignore
        .post(`/service/${this.projectId}`, this.ruleForm)
        .then(() => {
          this.$message.success("服务创建成功！");
          // @ts-ignore
          this.quit();
          this.$emit("afterEdit");
        })
        .finally(() => {
          // @ts-ignore
          this.loading = false;
        });
    }
  }
});
